import { render, staticRenderFns } from "./PoliticallyExposedPersonInformationCN.vue?vue&type=template&id=a7df56f2"
import script from "./PoliticallyExposedPersonInformationCN.vue?vue&type=script&lang=js"
export * from "./PoliticallyExposedPersonInformationCN.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports